// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const ApisLabel = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.common.apisLabel" description="Apis label." defaultMessage="APIs" />
);
ApisLabel.displayName = "ApisLabel";

export const ApiNameLabel = (props: { apiName: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.apiNameLabel"
        description="Api name label."
        defaultMessage="{apiName}"
        values={props}
    />
);
ApiNameLabel.displayName = "ApiNameLabel";

export const AddEndpointButtonCta = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.addEndpointButtonCta"
        description="Add endpoint button cta."
        defaultMessage="Add Endpoint"
    />
);
AddEndpointButtonCta.displayName = "AddEndpointButtonCta";

export const EndpointTitle = (props: { index: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.endpointTitle"
        description="Endpoint title."
        defaultMessage="Endpoint {index}"
        values={props}
    />
);
EndpointTitle.displayName = "EndpointTitle";

export const ReferenceIdLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.referenceIdLabel"
        description="Reference id label."
        defaultMessage="Reference ID"
    />
);
ReferenceIdLabel.displayName = "ReferenceIdLabel";

export const ReferenceIdTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.referenceIdTooltip"
        description="Reference id tooltip."
        defaultMessage="Unique ID for the API callers to identify this endpoint in Lens Studio."
    />
);
ReferenceIdTooltip.displayName = "ReferenceIdTooltip";

export const PathLabel = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.common.pathLabel" description="Path label." defaultMessage="Path" />
);
PathLabel.displayName = "PathLabel";

export const PathTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.pathTooltip"
        description="Path tooltip."
        defaultMessage="Path of the URL (without leading slash)."
    />
);
PathTooltip.displayName = "PathTooltip";

export const MethodLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.methodLabel"
        description="Method label."
        defaultMessage="Method"
    />
);
MethodLabel.displayName = "MethodLabel";

export const PreviewLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.previewLabel"
        description="Preview label."
        defaultMessage="Preview"
    />
);
PreviewLabel.displayName = "PreviewLabel";

export const ParametersLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.parametersLabel"
        description="Parameters label."
        defaultMessage="Parameters"
    />
);
ParametersLabel.displayName = "ParametersLabel";

export const ParameterNameLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.parameterNameLabel"
        description="Parameter name label."
        defaultMessage="Name"
    />
);
ParameterNameLabel.displayName = "ParameterNameLabel";

export const ParameterLocationLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.parameterLocationLabel"
        description="Parameter location label."
        defaultMessage="Parameter Location"
    />
);
ParameterLocationLabel.displayName = "ParameterLocationLabel";

export const ParameterLocationTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.parameterLocationTooltip"
        description="Parameter location tooltip."
        defaultMessage="How the parameter is passed to the service (query string, header, or URL path)."
    />
);
ParameterLocationTooltip.displayName = "ParameterLocationTooltip";

export const DefaultValueLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.defaultValueLabel"
        description="Default value label."
        defaultMessage="Default Value"
    />
);
DefaultValueLabel.displayName = "DefaultValueLabel";

export const RequiredLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.requiredLabel"
        description="Required label."
        defaultMessage="Required"
    />
);
RequiredLabel.displayName = "RequiredLabel";

export const ConstantLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.constantLabel"
        description="Constant label."
        defaultMessage="Constant"
    />
);
ConstantLabel.displayName = "ConstantLabel";

export const DeleteParameterButtonCta = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.deleteParameterButtonCta"
        description="Delete parameter button cta."
        defaultMessage="Delete Parameter"
    />
);
DeleteParameterButtonCta.displayName = "DeleteParameterButtonCta";

export const AddParameterButtonCta = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.addParameterButtonCta"
        description="Add parameter button cta."
        defaultMessage="Add Parameter"
    />
);
AddParameterButtonCta.displayName = "AddParameterButtonCta";

export const ParameterNameTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.parameterNameTooltip"
        description="Parameter name tooltip."
        defaultMessage="Name of the parameter that will be used to fill the API request."
    />
);
ParameterNameTooltip.displayName = "ParameterNameTooltip";

export const OptionalLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.optionalLabel"
        description="Optional label."
        defaultMessage="Optional"
    />
);
OptionalLabel.displayName = "OptionalLabel";

export const YesLabel = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.common.yesLabel" description="Yes label." defaultMessage="Yes" />
);
YesLabel.displayName = "YesLabel";

export const NoLabel = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.common.noLabel" description="No label." defaultMessage="No" />
);
NoLabel.displayName = "NoLabel";

export const GetMethod = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.common.getMethod" description="Get method." defaultMessage="GET" />
);
GetMethod.displayName = "GetMethod";

export const PostMethod = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.common.postMethod" description="Post method." defaultMessage="POST" />
);
PostMethod.displayName = "PostMethod";

export const DeleteMethod = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.common.deleteMethod"
        description="Delete method."
        defaultMessage="DELETE"
    />
);
DeleteMethod.displayName = "DeleteMethod";
